import {Link} from "react-router-dom";
import ReactCountryFlag from "react-country-flag";
import React from "react";
import styles from './playerCard.module.css'
import classNames from "classnames";
import { connect } from "react-redux";
import { mapDispatchToProps, mapStateToProps } from "pages/PlayersPage/maps";

export const PlayerCard = connect(mapStateToProps, mapDispatchToProps)(function({
    editablePlayer,
    setEditablePlayer
}: any) {
    const classList = classNames(styles.playerCard, {[styles.isPlayerPage]: true});

    console.debug('mapStateToProps: ', mapStateToProps)


    return (<div className={classList}>
        <img src={editablePlayer.avatar} alt={''}/>
        <div className={styles.playerInfo}>
            <p className={styles.country}>
                {editablePlayer.country && <ReactCountryFlag
                    svg
                    countryCode={editablePlayer.country.toLowerCase()}
                    style={{
                        width: '16px',
                        height: '12px',
                    }}
                />}
            </p>
            <p className={styles.name}>{editablePlayer.name}</p>
        </div>
    </div>);
})